import { render, staticRenderFns } from "./NoRealQueryManagementPage.vue?vue&type=template&id=e48e0b50&"
import script from "./NoRealQueryManagementPage.vue?vue&type=script&lang=js&"
export * from "./NoRealQueryManagementPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports